import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const LayImage = (props) => {
    return (
        <LazyLoadImage {...props} />
    );
};

export default LayImage;
